import { render, staticRenderFns } from "./report-assignments-home.vue?vue&type=template&id=689b802c&scoped=true"
import script from "./report-assignments-home.vue?vue&type=script&lang=js"
export * from "./report-assignments-home.vue?vue&type=script&lang=js"
import style0 from "./report-assignments-home.vue?vue&type=style&index=0&id=689b802c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689b802c",
  null
  
)

export default component.exports